
import React from 'react';
import { Button } from "@/components/ui/button";
import { BookOpen } from 'lucide-react';

interface ImportInputProps {
  onProcessed: (result: any) => void;
}

export const ImportInput: React.FC<ImportInputProps> = ({ onProcessed }) => {
  const handleConnect = () => {
    // Simulate connection and import process
    setTimeout(() => {
      onProcessed([
        {
          name: 'Atorvastatin',
          dosage: '20mg',
          frequency: 'once daily',
          source: 'Connected EHR'
        },
        {
          name: 'Levothyroxine',
          dosage: '100mcg',
          frequency: 'once daily',
          source: 'Connected EHR'
        }
      ]);
    }, 3000);
  };

  return (
    <div className="p-4 space-y-4 flex flex-col items-center">
      <p className="text-sm text-gray-600 text-center">
        Connect to your electronic health records to automatically import your medications.
      </p>
      
      <div className="border rounded-lg p-6 bg-blue-50 w-full max-w-md">
        <div className="flex flex-col items-center gap-4">
          <div className="rounded-full bg-blue-100 p-4">
            <BookOpen className="h-6 w-6 text-blue-600" />
          </div>
          <h3 className="font-medium text-center">Health Record Providers</h3>
          <div className="grid grid-cols-2 gap-3 w-full">
            <Button variant="outline" className="bg-white flex gap-2 h-auto py-3 justify-start">
              <img src="/healthgorilla.svg" alt="Health Gorilla" className="h-5 w-5" />
              <span>Health Gorilla</span>
            </Button>
            <Button variant="outline" className="bg-white flex gap-2 h-auto py-3 justify-start">
              <img src="/placeholder.svg" alt="Epic" className="h-5 w-5" />
              <span>Epic</span>
            </Button>
          </div>
        </div>
      </div>
      
      <Button onClick={handleConnect}>
        Connect Health Records
      </Button>
    </div>
  );
};
